import { render } from "./legal_matters.html?vue&type=template&id=1667f46a&external"
import script from "./legal_matters.js?vue&type=script&lang=js&external"
export * from "./legal_matters.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__